import React from 'react';
import {Select } from 'antd';
import { toast } from 'react-toastify';
import services from '../../services';
import { withRouter } from 'react-router-dom';
import FormleftNev from '../common/FormleftNev';
import queryString, { parse } from 'query-string'
import FormNavbar from '../common/wizard_navbar';
import Lang from '../../lang'
import { Input, TextArea } from '@progress/kendo-react-inputs';
import $ from "jquery";

const moment = require('moment');

const { Option } = Select
const InputFieldsAll = {
    Informações: [
        {
            key: "TextoInformacoes",
            type: "textArea",
            display: "TextoInformacoes"
        }
    ],
   
}

let apiFilters = {
    Filters: null,
    SortBy: 'ID',
    Page: 1,
    PageSize: 100,
    Filters: null,
    IsSortTypeDESC: false,
    IsPagination: false,
    
};

class Informacoesform extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            informacao: '',
            id :'',
            error:null,
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        let parsed = queryString.parse(window.location.search)
        if(parsed.id){
            this.getEntidadeById(parsed.id)
        }
    }

    handleChangeTexto = (e) => {
        this.setState({ informacao: e.value });
    }
    createInputs(nevkey) {
        let inputs = InputFieldsAll[nevkey].map((row, i) => {
            switch (row.type) {
                
                case "textArea":
                    return(
                        <div className="col-md-12">
                            <div className="input-box active-grey" style={{marginTop:"25px"}}>
                            <label style={{position: "absolute",zIndex: "1",top: "-12px",left: "16px",backgroundColor: "white"}} className='k-label'>Descrição</label>
                                <TextArea
                                    id={row.key}
                                    name={row.key}
                                    type={row.type}
                                    style={{ width: "100%" , height: "200px",padding: "0" , paddingTop:"11px" }}
                                    className="input-1 k-textbox textareaFrases"
                                    label={"Descrição"}
                                    row={50}
                                    cols={50}
                                    value={this.state ? this.state.informacao : ""}
                                    onChange={(e) => this.handleChangeTexto(e)}
                                />
                                
                            </div>
                        </div>
                    )
                break;
                default:
                    
            }
        });
        return inputs
    }

    

    createInputFields = () => {
        try {
            let InputFieldsdivs = Object.keys(InputFieldsAll).map((nevkey) => {
                return (<div className="bg-white middle p20" id={nevkey}>
                    <div className="head" style={{marginBottom: "1px"}}>
                        <h2> {Lang.langCheck.langRequest(`${nevkey}`)}</h2>
                       
                    </div>
                    <div className="row">
                        {this.createInputs(nevkey)}
                    </div>
                </div>
                )
            });
    
            return InputFieldsdivs;
        } catch (error) {
            this.setState({error})
        }
    }

    getEntidadeById = async (id) => {
        try {
            let parsed = queryString.parse(window.location.search)
            if(parsed.id){
                var data = {id: parsed.id}
            }else{
                var data = {id: "0"}
            }

            let _user = await services.apiCall.requestApi(
                "/Transversal/GetInformacoes",
                data,
                "get"
            );
            if (_user) {
                
                var resp = _user.filter((item, index) => item.idInformacaoIVDPEncrypt === decodeURIComponent(id))
                if (resp.length> 0) {
                    this.setState({
                        informacao: resp[0].informacao,
                        id : resp[0].idInformacaoIVDP,
                    })
                }
            }  
        } catch (error) {
            this.setState({error})
        }
    }

    handleSubmit = (e, backUrl) => {
        e.preventDefault();
        try {
            let parsed = queryString.parse(window.location.search)
                if(parsed.id != undefined && parsed.id != null){
                // é o update
                    this.handleAddandUpdateInformacao(parsed.id, backUrl);
                } else {
                    // adiciona novo
                    this.handleAddandUpdateInformacao(null,backUrl);
                }
            
        } catch (error) {
            this.setState({error})
        }
    }

    handleAddandUpdateInformacao = async (id, backUrl) => {
        try {
            if(id){
                var data = {
                    idInformacaoIVDPEncrypt: id,
                    informacao: $("#TextoInformacoes").val(),
                    criadoPor:  window.localStorage.getItem('username')
                }
                var res = await services.apiCall.requestApi(`/Transversal/UpdateInformacoes`, data, 'post')
                if (res) {
                    if (backUrl) {
                        this.props.history.push({
                            pathname: backUrl,
                            state:{topBarMenu : this.props.topBarMenuOption}
                        })
                    }
                }
            }else{
                    var data = {
                        idInformacaoIVDPEncrypt: "",
                        informacao: $("#TextoInformacoes").val(),
                        criadoPor:  window.localStorage.getItem('username'),
                    }
                    var res = await services.apiCall.requestApi(`/Transversal/AddInformacoes`, data, 'post')
                    if (res) {
                        if (backUrl) {
                            this.props.history.push({
                                pathname: backUrl,
                                state:{topBarMenu : this.props.topBarMenuOption}
                            })
                        }
                    }
            }
            
        } catch (error) {
            this.setState({error})
        }
    }

    

    render() {
        console.log("state",this.state)
        console.log("props",this.props)
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="dashboard">
                {
                    
                    // (this.props.id && this.props.id.location && this.props.id.location.state && this.props.id.location.state.entidade_id) ?
                        this.state.id ?
                        <FormNavbar to={'/admin_dashboard_Informacoes'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Editar Informação" />
                        :
                        <FormNavbar to={'/admin_dashboard_Informacoes'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Criar nova Informação" />
                }
                <div className="full-container edit-ward">
                    <FormleftNev InputFieldsAll={InputFieldsAll} />
                    <div className="right-section">

                        <div className="row top-serch">
                            {
                                this.createInputFields()
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(Informacoesform);